import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

export interface ProjectCardActionsProps extends WithClassName {
  children?: React.ReactNode
  isLoading?: boolean
}

export const ProjectCardActions = React.memo(
  ({ children, isLoading, className }: ProjectCardActionsProps) => {
    if (isLoading) {
      return null
    }
    return (
      <div className={classNames("project-card__actions", className)}>
        {children}
      </div>
    )
  }
)
